import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig } from '../config/config'; // Importing development configuration

/**
 * Class representing a builder view.
 * @extends JetView
 */
export default class builderView extends JetView {
    /**
     * Configures the view.
     * @returns {Object} An empty configuration object.
     */
    config() {
        return {};
    }

    /**
     * Initializes the view.
     * Opens a new window and redirects after a delay.
     */
    init() {
        // Opens a new window with the dashboard URL and token from local storage
        window.open('/sitebuilder/#/dashboard?tt=' + localStorage.getItem('x-token'), '_blank');
        // Delays the redirection to the top dashboard
        webix.delay(
            function () {
                location.href = '/#!/top/dashboard'; // Redirects to the top dashboard
            },
            '',
            '',
            1000, // Delay time in milliseconds
        );
    }
}

// FILE DOCUMENTED
